// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"773":"cc00fa56","1628":"06acb9cc","3395":"9334308d"}[chunkId] + ".chunk.css";
};